module.exports = __webpack_public_path__ + "media/logos/wa-logo-35d9e841.svg";